import React, { Component } from 'react';
import { Divider, HTMLTable, Button, Intent, Tag, InputGroup, FormGroup } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class WebNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      content: '',
      news: [
        { id: 104, title: 'SROFilter v4.2 Security Core Update Released', category: 'PATCH_NOTES', date: '30.07.2026', author: '[GM] Nozich' },
        { id: 103, title: 'Weekend Double EXP & Alchemy Rate Boost Event', category: 'EVENT', date: '28.07.2026', author: '[GM] Merlin' },
        { id: 102, title: 'Fortress War Registration Notice & Rules', category: 'NOTICE', date: '25.07.2026', author: '[GM] Staff' },
      ]
    };
  }

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          Web Portal News & Patch Notes CMS
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Publish website news, patch notes, event announcements, and maintenance notices.
        </p>

        <Divider className="mb-4" />

        <h5 className="mb-3 font-weight-bold" style={{ color: '#182026' }}>Publish New Announcement</h5>
        <FormGroup label="Post Title">
          <InputGroup placeholder="e.g. Server Maintenance & Cap 110 Update" value={this.state.title} onChange={(e) => this.setState({ title: e.target.value })} />
        </FormGroup>
        <FormGroup label="Content Body">
          <textarea className="form-control border-secondary mb-3" rows="3" placeholder="Enter announcement text..." value={this.state.content} onChange={(e) => this.setState({ content: e.target.value })} style={{ color: '#182026', backgroundColor: '#fff' }}></textarea>
        </FormGroup>
        <Button intent={Intent.PRIMARY} icon="plus" small text="Publish News Article" />

        <Divider className="my-4" />

        <h5 className="mb-3 font-weight-bold" style={{ color: '#182026' }}>Published News Feed</h5>
        <HTMLTable bordered condensed striped style={{ width: '100%', fontSize: '0.82rem' }}>
          <thead>
            <tr>
              <th style={{ color: '#182026' }}>ID</th>
              <th style={{ color: '#182026' }}>Title</th>
              <th style={{ color: '#182026' }}>Category</th>
              <th style={{ color: '#182026' }}>Date</th>
              <th style={{ color: '#182026' }}>Author</th>
            </tr>
          </thead>
          <tbody>
            {this.state.news.map((n, i) => (
              <tr key={i}>
                <td className="font-mono" style={{ color: '#5c7080' }}>#{n.id}</td>
                <td className="font-weight-bold" style={{ color: '#182026' }}>{n.title}</td>
                <td><Tag intent={Intent.PRIMARY} round>{n.category}</Tag></td>
                <td style={{ color: '#5c7080' }}>{n.date}</td>
                <td style={{ color: '#106ba3' }}>{n.author}</td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
      </SideMenuWrapper>
    );
  }
}
